import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/72cefc1d/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Dr. Rowland is an orthopedic surgeon specializing in arthroscopic and open surgeries of the upper and lower extremities. He has a dedicated clinical staff and assistants to aid in delivering high-quality and expert care.`}</p>
    </PageDescription>
    <p>{`Overview/general practice content, general fracture care for upper and lower extremities`}</p>

    </MDXLayout>;
}
MDXContent.isMDXComponent = true;
      